import { CircleHelp, ClipboardList, Contact, FileText, Lightbulb, Package, PiggyBank, Search, UserRound } from "lucide-react";

export const TYPES = {
  question: { label: "Question", icon: CircleHelp, hint: "Something you need the client to answer", client: true, shared: true },
  task: { label: "Task", icon: ClipboardList, hint: "Work to do before construction starts", client: false, shared: false },
  investigate: { label: "Investigate", icon: Search, hint: "Permits, site conditions, utilities — things to look into", client: false, shared: false },
  client_info: { label: "Client info", icon: UserRound, hint: "Details the client knows: access, pets, schedule constraints", client: true, shared: true },
  contact: { label: "Contact", icon: Contact, hint: "A person to reach — supplier, neighbour, property manager", client: true, shared: true },
  document: { label: "Document", icon: FileText, hint: "Survey, drawings, HOA rules, warranty papers", client: true, shared: true },
  product: { label: "Product", icon: Package, hint: "A specific product or model the client wants", client: true, shared: true },
  suggestion: { label: "Suggestion", icon: Lightbulb, hint: "An idea worth considering", client: true, shared: true },
  saving: { label: "Potential saving", icon: PiggyBank, hint: "A client supplier, a trade, a material — flagged for estimating", client: false, shared: false },
};

export const STATUSES = {
  open: ["Open", "bg-secondary text-foreground"],
  in_progress: ["In progress", "bg-sky-100 text-sky-800"],
  done: ["Done", "bg-primary/10 text-primary"],
  not_needed: ["Not needed", "bg-muted text-muted-foreground"],
};

export const CLOSED = ["done", "not_needed"];
export const fmtDate = (iso) => (iso ? new Date(iso + "T12:00:00").toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" }) : "");
export const monthsUntil = (iso) => {
  if (!iso) return null;
  const days = Math.round((new Date(iso + "T12:00:00") - new Date()) / 86400000);
  if (days < 0) return null;
  if (days < 14) return `${days} day${days === 1 ? "" : "s"}`;
  if (days < 60) return `${Math.round(days / 7)} weeks`;
  return `${Math.round(days / 30)} months`;
};
